import { Button, Container, Flex, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Text } from '@chakra-ui/react'
import React from 'react';
import answers from './answers';

const audio = new Audio("./song.mp3");

const playAudio = () => {
    audio.play();
}

const setVolume = (volume) => {
    audio.volume = volume / 100
}

const pauseAudio = () => {
    audio.pause()
}

const stopAudio = () => {
    pauseAudio()
    audio.currentTime = 0;
}


function ThePage() {

    const [answer, setAnswer] = React.useState({})
    const [isPlaying, setPlaying] = React.useState(false);
    const [volume, currentVolume] = React.useState(50);

    React.useEffect(() => {
        setPlaying(answer.play)
    }, [answer])

    React.useEffect(() => {
        setVolume(volume)
    }, [volume])

    if (isPlaying) playAudio(volume); else stopAudio();

    return (
        <Flex
            width={"100vw"}
            height={"100vh"}
            justify={"center"}
            align={"center"}

            backgroundImage={(answer && answer.background) ?? 'waves.svg'}
            sx={{
                transition: 'background-image .3s linear'
            }}
        >
            <Flex
                position={"absolute"}
                top={"10px"}
                right={"10px"}
                opacity={answer && answer.play ? 1 : 0}
            >
                <Button
                    color={"black"}
                    onClick={() => {
                        setPlaying(current => {
                            return !current;
                        })
                    }}
                >{isPlaying ? "Pause" : "Play"}</Button>
                <Slider
                    marginX={"10px"}
                    defaultValue={50}
                    max={100}
                    min={0}
                    width={"100px"}
                    onChange={(v) => currentVolume(() => v)}
                >
                    <SliderTrack>
                        <SliderFilledTrack />
                    </SliderTrack>
                    <SliderThumb />
                </Slider>
            </Flex>
            <Container
                align="center"
            >
                <Text
                    fontSize={"6xl"}
                    fontFamily={`'Playfair Display', serif`}
                    fontStyle={"italic"}
                    mb={10}
                    bg={"white"}
                >
                    Do you love me?
                </Text>
                <Container align={"center"}>
                    {answers.map(
                        ({ answer }, index) =>
                            <Button key={index} fontFamily={`'Playfair Display', serif`} marginX={3} onClick={() => setAnswer(answers[index])}>{answer}</Button>
                    )}
                </Container>

            </Container>
            {answer &&
                <Container
                    alignContent={"center"}
                    fontFamily={`'Raleway', sans-serif`}
                >
                    <Text
                        align={"center"}
                        fontSize={"3xl"}
                    >{answer.response}</Text>
                </Container>

            }
        </Flex>
    )
}

export default ThePage